module.exports = __webpack_public_path__ + "0fb4a62e37e552a83c14639e50d95505.png";